export default "__VITE_PUBLIC_ASSET__ef77923e__"